import { gql } from '@apollo/client';

// Preset gallery LIST for a SmallApp's Config-Engine PresetField — card fields only
// (presetId / originalFileName / thumbnailURL) resolved from the curated
// `AppMeta.presetGroupId` folder. Returns a GraphQLJSONObject scalar (array), so there is
// no sub-selection. The per-preset CONFIG is NOT included here — it loads on select via the
// app's own microservice (`api.onLoad`), so open-api never reaches into the SmallApp REST DB.
// Backend: open-api common.resolver.getPresetsSmallApp.
export const GET_PRESETS_SMALL_APP = gql`
  query GetPresetsSmallApp($teamId: String, $payload: PresetInput!) {
    getPresetsSmallApp(teamId: $teamId, payload: $payload)
  }
`;
